import { PipeTransform, Pipe } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Pipe({name: 'numSelected'})
export class NumSelectedPipe implements PipeTransform {


  transform(checkboxArray: boolean[]): Number {
    return (checkboxArray.filter(value => value)).length;   
  }
}


// WEBPACK FOOTER //
// ./src/pipes/numSelected.ts